export type ResponsibleCategoryProjection = {
  values: string[];
  injected: string[];
};

const unique = (values: string[]) => values.filter((value, index) => values.indexOf(value) === index);

export function applyResponsibleCategories(currentValues: string[], previousInjected: string[], assignedValues: string[]): ResponsibleCategoryProjection {
  const manual = currentValues.filter(value => !previousInjected.includes(value));
  const values = unique([...manual, ...assignedValues]);

  return {
    values,
    injected: unique(assignedValues.filter(value => !manual.includes(value))),
  };
}

export function clearResponsibleCategories(currentValues: string[], injectedValues: string[]): string[] {
  return unique(currentValues.filter(value => !injectedValues.includes(value)));
}

export function syncInjectedCategoriesAfterManualChange(nextValues: string[], injectedValues: string[]): string[] {
  return unique(injectedValues.filter(value => nextValues.includes(value)));
}

export function stripInjectedResponsibleCategories(
  values: Record<string, unknown>,
  categoryLevel: string | null,
  injectedCategories: string[],
): Record<string, unknown> {
  if (!categoryLevel || !injectedCategories.length || !Array.isArray(values[categoryLevel])) return values;

  return {
    ...values,
    [categoryLevel]: (values[categoryLevel] as unknown[]).filter((value): value is string => typeof value === 'string' && !injectedCategories.includes(value)),
  };
}
